import { axios } from '@/plugins/axios-pol'

export default class TrayectoriaLaboralApiRepository {
  async getTrayectoriaLaboral(idPersonal) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/TrayectoriaLaboral`)
    return data.data
  }

  async getTrayectoriaLaboralById(idPersonal, idTrayectoriaLaboral) {
    const { data } = await axios.get(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/TrayectoriaLaboral/${idTrayectoriaLaboral}`
    )
    return data.data
  }

  async getAllTrayectoriaLaboralRegistrada() {
    const { data } = await axios.get('/personal/api/EstadoFuerza/TrayectoriaLaboral')
    return data.data
  }

  async createTrayectoriaLaboral(payload) {
    const { data } = await axios.post('/personal/api/EstadoFuerza/TrayectoriaLaboral', payload)
    return data.data
  }
  async getTrayectoriaLaboralEspecifica(idTrayectoriaLaboral) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/TrayectoriaLaboral/${idTrayectoriaLaboral}`)
    return data.data
  }

  async updateTrayectoriaLaboralEspecifica(idTrayectoriaLaboral, payload) {
    const { data } = await axios.put(`/personal/api/EstadoFuerza/TrayectoriaLaboral/${idTrayectoriaLaboral}`, payload)
    return data.data
  }
}
